if (!customElements.get('misc-content')) {
  customElements.define(
    'misc-content',
    class MiscContent extends HTMLElement {
      constructor() {
        super();
        this.videos = Array.from(this.querySelectorAll('.js-misc-content-video'));
        if (!this.videos.length) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.5 }
        );

        this.videos.forEach((video) => this.observer.observe(video));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
